/**
 * Simple enum for expressing which view should be displayed.
 */
export const VIEWS = {
  PROPERTY_TABLE: 1,
  INVESTMENT_CALCULATOR: 2,
  SCHEDULE_E_CALCULATOR: 3
};
